import { get } from 'lodash'
import AppButton from '@theme/components/atom/AppButton'
import CategoryBox from '@theme/components/category/CategoryBox'
import FeatureBoxes from '@theme/components/content/FeatureBoxes'
import PageHomepage from '~/themes/base/components/shop/PageHomepage'
import Slider from '@theme/components/content/Slider'
import UserReviews from '@theme/components/content/UserReviews'

export default {
  extends: PageHomepage,
  components: { AppButton, CategoryBox, FeatureBoxes, Slider, UserReviews },
  computed: {
    criticalContentBreakpoints() {
      return get(this.$themeSettings, 'components.Slider.image.srcsetBreakpoints').length
        ? this.$themeSettings.components.Slider.image.srcsetBreakpoints
        : Slider.extends.props.srcsetBreakpointsDefaults.default(this.$themeSettings)
    },
    criticalContentImageRatio() {
      const width = this.$themeSettings.components.Slider.image.width
      const height = this.$themeSettings.components.Slider.image.height
      return 1 / (width / height)
    },
    criticalContentPaths() {
      const elements = []

      if (this.featuredBanners.length > 0) {
        const banner = this.featuredBanners[0]
        elements.push(
          banner.main_image_translatable && banner.main_image_translatable.length > 0
            ? banner.main_image_translatable[0].path
            : banner.main_image[0].path,
        )
      }

      return elements
    },
    customCategories() {
      const source = this.$store.state.category.categoriesCustom
      return {
        title: source.title,
        items: source.configurable_categories.map(item => {
          const category = item.configurable_categories?.[0]?.entity.data
          return {
            action_title: item.action_title,
            type: item.category_item_type?.[0],
            title: item.title,
            image: category?.mainImage || '',
            link: category?.slug || '',
          }
        }),
      }
    },
    stockCategories() {
      const source = this.$store.state.category.categoriesStock
      return {
        title: source.title,
        items: source.configurable_categories.map(item => {
          const category = item.configurable_categories?.[0]?.entity.data
          return {
            action_title: item.action_title,
            type: item.category_item_type?.[0],
            title: item.title,
            image: category?.mainImage || '',
            link: category?.slug || '',
          }
        }),
      }
    },
  },
}
